"use client";

import type React from "react";
import { createContext, useContext, useState } from "react";

interface LayoutContextType {
	mobileHeaderBackAction: React.ReactNode;
	setMobileHeaderBackAction: (node: React.ReactNode) => void;
	mobileHeaderLeftAction: React.ReactNode;
	setMobileHeaderLeftAction: (node: React.ReactNode) => void;
	mobileHeaderRightActions: React.ReactNode[];
	setMobileHeaderRightActions: (nodes: React.ReactNode[]) => void;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export function LayoutProvider({ children }: { children: React.ReactNode }) {
	const [mobileHeaderBackAction, setMobileHeaderBackAction] =
		useState<React.ReactNode>(undefined);
	const [mobileHeaderLeftAction, setMobileHeaderLeftAction] =
		useState<React.ReactNode>(undefined);
	const [mobileHeaderRightActions, setMobileHeaderRightActions] = useState<
		React.ReactNode[]
	>([]);

	return (
		<LayoutContext.Provider
			value={{
				mobileHeaderBackAction,
				setMobileHeaderBackAction,
				mobileHeaderLeftAction,
				setMobileHeaderLeftAction,
				mobileHeaderRightActions,
				setMobileHeaderRightActions,
			}}
		>
			{children}
		</LayoutContext.Provider>
	);
}

export function useLayout() {
	const context = useContext(LayoutContext);
	if (context === undefined) {
		throw new Error("useLayout must be used within a LayoutProvider");
	}
	return context;
}
